import { render, staticRenderFns } from "./GroupRequest.vue?vue&type=template&id=229ce221"
import script from "./GroupRequest.vue?vue&type=script&lang=js"
export * from "./GroupRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports